import { inject, Injectable, Injector } from '@angular/core';

import { firstValueFrom, of } from 'rxjs';

import { AskTemplatesService } from '@core/ask-hr-templates-logic';
import { I18nService } from '@core/i18n-legacy';
import type { DataSourceService } from '@core/views-types';

import { AskTemplatesDialogService } from '../ask-templates-dialog.service';

@Injectable()
export class AskTemplatesDataSourceService implements DataSourceService {
  private readonly i18n = inject(I18nService);
  private readonly injector = inject(Injector);
  private readonly askTemplatesDialogService = inject(AskTemplatesDialogService);
  private readonly askTemplatesService = inject(AskTemplatesService);

  public hasMoreSettings$ = of(true);
  public hasSampleData$ = of(false);
  public isSampleDataInProgress$ = of(false);
  public viewPageHeaderComponent$ = of(null);
  public pageCtaVisible$ = of(false);

  public refreshData$ = this.askTemplatesService.getViewRefreshEvents$();
  public translations = {
    dataSourceName: 'app.views_candidates.name',
    pageCta: 'app.views_candidates.view_add_candidate',
  };

  public defaultEmptyState$ = of({
    header: this.i18n.translate('tlc.ask_hr.forms.empty_state.heading'),
    description: this.i18n.translate('tlc.ask_hr.forms.empty_state.subheading'),
    icon: <any>'',
  });

  public filteredEmptyState$ = of({
    header: this.i18n.translate('tlc.ask_hr.forms.empty_state_filtered.heading'),
    description: this.i18n.translate('tlc.ask_hr.forms.empty_state_filtered.subheading'),
    icon: <const>'search',
  });

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onRemoveSampleData = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onPageCtaClick = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onRecordClick = (template: { id: number }) => {};

  public editTemplate(id: number) {
    this.askTemplatesDialogService.openEditTemplateDialog(this.injector, { id, firstView: 'form' });
  }

  public deleteTemplate(id: number) {
    firstValueFrom(this.askTemplatesService.confirmDelete(id));
  }

  public duplicateTemplate(id: number) {
    firstValueFrom(this.askTemplatesService.duplicateTemplate(id));
  }

  public previewTemplate(id: number) {
    this.askTemplatesDialogService.openEditTemplateDialog(this.injector, {
      id,
      firstView: 'preview',
    });
  }

  public copyTemplateLink(id: number) {
    this.askTemplatesService.copyTemplateLink(id);
  }
}
